import React from "react";
import CTA from "./CTA";
import { getAwsAssets } from "@src/utils";
import { showPaymentLoaderAction } from "@src/components/BottomSheets/store/actions";
import { useDispatch } from "react-redux";
import { Image } from "@src/components/Image";
function PaymentLoader({ heading, children, button, className }) {
  // const animationOptions = {
  //   loop: true,
  //   autoplay: true,
  //   animationData: animationData,
  //   rendererSettings: {
  //     preserveAspectRatio: "xMidYMid slice",
  //   },
  // };

  const dispatch = useDispatch();

  const LottieStyle = {
    height: 200,
    width: 200,
  };

  const onCancelClick = () => {
    dispatch(showPaymentLoaderAction(false));
  };

  return (
    <div
      className={
        className ? `PromtPlaceholder ${className}` : "PromtPlaceholder"
      }
    >
      {/*<lottie-player
        autoplay
        loop
        src={getAwsAssets("LoadingLottie.json", "lottieJSONs")}
        style={LottieStyle}
    ></lottie-player>*/}
      <Image src={getAwsAssets("planeWithCloud.svg", "bottomSheets")} height={200} width={200} />
      <div className="PromtPlaceholder__Heading">{heading}</div>
      <div className="PromtPlaceholder__Body">{children}</div>

      {button ? (
        <div className="PromtPlaceholder__Action">
          <CTA label={button} onClick={onCancelClick} />
        </div>
      ) : (
        ""
      )}
    </div>
  );
}

export default PaymentLoader;
